export const mainUrl = process.env.REACT_APP_BACKEND_URI;
